//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import store from '@/store'
import { getConfig, addFile } from '@/api/wx.js'
import { getZbConfig, addZb, getZbAll } from '@/api/zhigongxiaojia.js'
export default {
  name: 'index',
  props: {},
  data () {
    return {
      list: []
    }
  },
  created () {
    var element = document.createElement('script')
    element.src = 'http://res.wx.qq.com/open/js/jweixin-1.2.0.js'
    var element2 = document.createElement('script')
    element2.src = 'https://open.work.weixin.qq.com/wwopen/js/jwxwork-1.0.0.js'
    element.onload = this.wxconfig2
    document.body.appendChild(element)
    document.body.appendChild(element2)
    this.wxconfig()
    this.getZb()
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    },
    userid () {
      return this.$store.state.user.userid
    }
  },
  mounted () { },
  methods: {
    getZb () {
      getZbAll({}).then(res => {
        this.list = res.obj
      })
    },
    wxconfig () {
      let ua = window.navigator.userAgent.toLowerCase()
      // alert('ua:' + ua)
      let href = window.location.href.split('#')[0]
      if ((ua.match(/MicroMessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')) {
        href = window.location.href.split('#')[0]
        // alert('企业微信客户端')
      } else if (ua.match(/micromessenger/i) == 'micromessenger') {
        href = store.state.user.wechatSignUrl
        // alert('微信客户端')
      }

      getZbConfig({
        url: href
      }).then(res => {
        wx.agentConfig({
          // debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          corpid: res.obj.corpid, // 必填，公众号的唯一标识
          agentid: res.obj.agentid,
          timestamp: res.obj.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.obj.nonceStr, // 必填，生成签名的随机串
          signature: res.obj.signature, // 必填，签名，见附录1
          jsApiList: ['startLiving', 'launchMiniprogram'], // 必填，传入需要使用的接口名称
          success: function (res) {
            // 回调
            console.log('agentconfigsuc', res)
          },
          fail: function (res) {
            // console.log('agentconfigerr', res)
            if (res.errMsg.indexOf('function not exist') > -1) {
              alert('版本过低请升级')
            }
          }
        })
      })
    },
    wxconfig2 () {
      let ua = window.navigator.userAgent.toLowerCase()
      // alert('ua:' + ua)
      let href = window.location.href.split('#')[0]
      if ((ua.match(/MicroMessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')) {
        href = window.location.href.split('#')[0]
        // alert('企业微信客户端')
      } else if (ua.match(/micromessenger/i) == 'micromessenger') {
        href = store.state.user.wechatSignUrl
        // alert('微信客户端')
      }
      getConfig({
        url: href
      }).then(re => {
        var configs = re.returnValue
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: configs.appId, // 必填，公众号的唯一标识
          timestamp: configs.timestamp, // 必填，生成签名的时间戳
          nonceStr: configs.nonceStr, // 必填，生成签名的随机串
          signature: configs.signature, // 必填，签名，见附录1
          jsApiList: ['wx-open-launch-weapp'], // 必填，传入需要使用的接口名称
          openTagList: ['wx-open-launch-weapp']
        })
        // 通过ready接口处理成功验证
        wx.ready(function () {
          // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
        })
        // 通过error接口处理失败验证
        wx.error(function (res) {
          // console.log(res)
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
        })
      })
    },
    create () {
      wx.invoke('startLiving', {
        'liveType': 1,
        'theme': ''
      }, function (res) {
        // console.log(res)
        if (res.err_msg == 'startLiving:ok') {
          let livingId = res.livingId
          addZb({
            accountid: this.accountid,
            livingId: livingId
          })
        }
      })
    },
    join (id) {
      wx.invoke('startLiving', {
        'livingId': id
      }, function (res) {
        if (res.err_msg == 'startLiving:ok') {
          // livingId = res.livingId
        }
      })
    }
  }
}
